module.exports = {
	"id": "TT",
	"name": "Trinidad and Tobago",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.013272,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.013272,
			"19": null,
			"20": null,
			"21": 0.013272,
			"22": 0.106176,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.046452,
			"27": null,
			"28": 0.019908,
			"29": 0.013272,
			"30": null,
			"31": 0.013272,
			"32": 0.019908,
			"33": 0.013272,
			"34": 0.06636,
			"35": 0.039816,
			"36": 0.03318,
			"37": 0.013272,
			"38": 0.046452,
			"39": 0.039816,
			"40": 0.053088,
			"41": 0.006636,
			"42": 0.019908,
			"43": 0.079632,
			"44": 0.06636,
			"45": 0.039816,
			"46": 0.03318,
			"47": 0.053088,
			"48": 0.039816,
			"49": 1.254204,
			"50": 0.13272,
			"51": 0.69678,
			"52": 0.39816,
			"53": 27.977376,
			"54": 7.624764,
			"55": 0.318528,
			"56": 0.046452,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.006636,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.006636,
			"12": 0.006636,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.013272,
			"32": null,
			"33": 0.013272,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.006636,
			"38": 0.026544,
			"39": 0.013272,
			"40": 0.039816,
			"41": 0.013272,
			"42": 0.019908,
			"43": 0.086268,
			"44": 0.019908,
			"45": 0.072996,
			"46": 0.039816,
			"47": 0.311892,
			"48": 0.371616,
			"49": 4.824372,
			"50": 0.159264,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.019908
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.06636,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.019908,
			"34": null,
			"35": null,
			"36": 0.013272,
			"37": 0.451248,
			"38": 0.019908,
			"39": 0.013272,
			"40": 0.378252,
			"41": 0.053088,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.019908
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.03318,
			"6": null,
			"7": 0.039816,
			"8": 0.139356,
			"9": 0.112812,
			"10": 1.26084,
			"3.1": null,
			"3.2": null,
			"5.1": 0.06636,
			"6.1": 0.059724,
			"7.1": null,
			"9.1": 0.703416
		},
		"ios_saf": {
			"8": 0,
			"10": 3.72998415321,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.100518756869,
			"8.1-8.4": 0.185704144047,
			"9.0-9.2": 0.0885928026644,
			"9.3": 1.35160814321
		},
		"android": {
			"3": 0,
			"4": 0.0561014366925,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00701267958656,
			"4.1": 0.202365896641,
			"4.2-4.3": 0.505914741602,
			"4.4": 1.16009756589,
			"4.4.3-4.4.4": 1.17011567959
		},
		"ie": {
			"6": null,
			"7": 0.0534193857678,
			"8": 0.400645393258,
			"9": 0.407322816479,
			"10": 0.240387235955,
			"11": 4.24684116854,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0276068502894,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000766856952484
		},
		"edge": {
			"12": 0.152628,
			"13": 0.690144,
			"14": 1.950984
		},
		"ie_mob": {
			"10": 0.126031549296,
			"11": 0.513128450704
		},
		"bb": {
			"7": 0.060552,
			"10": null
		},
		"samsung": {
			"0": 4.81052
		},
		"and_uc": {
			"0": 0.507964
		},
		"op_mini": {
			"0": 0.371942292758
		},
		"and_chr": {
			"0": 26.244608
		},
		"and_ff": {
			"0": 0.020184
		}
	},
	"total": 98.257832
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TT.json
 ** module id = 666
 ** module chunks = 0
 **/